export default "__VITE_ASSET__BT7pi_8L__"